module.exports = __webpack_public_path__ + "img/modal-montants-forfaitaires.96398864.png";